(() => {
  'use strict';
  if (window.venluPagesR17Ready) return;
  window.venluPagesR17Ready = true;

  class AnimeDirectory extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const { signal } = this.abort;
      const input = this.querySelector('[data-directory-search]');
      const links = [...this.querySelectorAll('[data-directory-name]')];
      const empty = this.querySelector('[data-directory-empty]');
      const result = this.querySelector('[data-directory-result]');
      if (!input || !links.length) return;
      const update = () => {
        const query = input.value.trim().toLocaleLowerCase();
        let count = 0;
        for (const link of links) {
          link.hidden = !link.dataset.directoryName.toLocaleLowerCase().includes(query);
          if (!link.hidden) count++;
        }
        if (empty) empty.hidden = count > 0;
        if (result) result.textContent = query ? `${count} ${window.VenluI18n.t("r24.s_6d9359a1e67c",{},"anime worlds found.")}` : '';
      };
      input.addEventListener('input', update, { signal });
      this.querySelector('[data-directory-reset]')?.addEventListener('click', () => {
        input.value = '';
        update();
        input.focus();
      }, { signal });
      document.addEventListener('venlu:languagechange', update, { signal });
      update();
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  if (!customElements.get('vn-anime-directory')) customElements.define('vn-anime-directory', AnimeDirectory);

  const markCurrentLinks = (scope = document) => {
    const current = new URL(location.href);
    scope.querySelectorAll('[data-catalogue-links] a,.vn-service-page-r17 .page-aside nav a').forEach(link => {
      const target = new URL(link.href, location.href);
      const sameView = (target.searchParams.get('view') || '') === (current.searchParams.get('view') || '');
      if (target.pathname === current.pathname && sameView) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  };
  markCurrentLinks();
  document.addEventListener('shopify:section:load', event => markCurrentLinks(event.target));
  document.addEventListener('click', event => {
    document.querySelectorAll('.vn-catalogue-filters[open]').forEach(panel => {
      if (!panel.contains(event.target)) panel.open = false;
    });
  });
})();
